import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import encode from "nodejs-base64-encode";
import axios from "axios";
import BajaAltaMultiple from "../../BajaAltaMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import qrcode from "qrcode-js";
import moment from "moment";

function ReporteVentasArticulos() {
  const { user } = useContext(AuthContext);
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_ARTICULOS_DEVOLUCIONES = process.env.REACT_APP_URL_ARTICULOS_DEVOLUCIONES;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_UNIDADES_NEGOCIO = process.env.REACT_APP_URL_UNIDADES_NEGOCIO;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");

  const [totalTotalCantidad, setTotalTotalCantidad] = useState(0);
  const [totalTotalCantidadDev, setTotalTotalCantidadDev] = useState(0);
  const [totalTotalCantidadVentaReal, setTotalTotalCantidadVentaReal] = useState(0);
  const [totalTotalCantidadEntregado, setTotalTotalCantidadEntregado] = useState(0);
  const [totalTotalCantidadPorEntregar, setTotalTotalCantidadPorEntregar] = useState(0);
  const [totalTotalDinero, setTotalTotalDinero] = useState(0);
  const [totalTotalDineroBruto, setTotalTotalDineroBruto] = useState(0);
  const [totalTotalCosto, setTotalTotalCosto] = useState(0);
  const [totalTotalUtilidad, setTotalTotalUtilidad] = useState(0);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(true);
  const [fechaModificada, setFechaModificada] = useState(false);

  const [activo, setActivo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

useEffect(() => {
  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Danos unos segundos....",
      customClass: {
        icon: "animated-icon",
      },
    });
  } else {
    Toast.close();
  }
}, [cargando]);

useEffect(() => {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const round2 = (n) =>
    Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  const ABS_TOL = 1; // ✅ tolerancia: diferencia < $1

  // key base SIN precio
  const keyBase = (idArticulo, idCliente) => `${idArticulo}|${idCliente}`;

  // key para ventas sin área PERO con precioBruto (para repartir devoluciones por precio cercano)
  const keyVentaSinArea = (idArticulo, idCliente, precioBruto) =>
    `${idArticulo}|${idCliente}|${round2(precioBruto)}`;

  const fetchAll = async () => {
    try {
      Toast.fire({ icon: "info", title: "Cargando..." });
      setCargando(true);

      const [ventasRes, devolRes, clientesRes, marcasRes, unRes] =
        await Promise.all([
          axios.get(
            `${URL_ARTICULOS_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
            { headers }
          ),

          axios.get(
            `${URL_ARTICULOS_DEVOLUCIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
            { headers }
          ),

          axios.get(URL_CLIENTES, { headers }),
          axios.get(URL_MARCAS, { headers }),
          axios.get(URL_UNIDADES_NEGOCIO, { headers }),
        ]);

      const allVentas = ventasRes.data ?? [];
      const allDevol = devolRes.data ?? [];

      // 1) Normaliza ventas
      const arrayTabla = allVentas
        .map((a) => {
          const precio = Number(a?.precio ?? 0);
          const precioBruto = Number(a?.precioBruto ?? 0);
          const cantidad = Number(a?.cantidad ?? 0);
          const entregado = Number(a?.entregadoCantidad ?? 0);
          const porEntregar = Number(a?.porEntregar ?? 0);
          const costoMX = Number(a?.costoUnitario ?? 0);

          return {
            SKU: a.articulos?.[0]?.SKU ?? "",
            nombre: a.articulos?.[0]?.nombre ?? "",
            marca: a.articulos?.[0]?.marcas?.[0]?.name ?? "",
            idMarca: String(a.articulos?.[0]?.marcas?.[0]?._id ?? ""),
            unidadNegocio: a.articulos?.[0]?.unidadesNegocio?.[0]?.name ?? "",
            idUnidadNegocio: String(
              a.articulos?.[0]?.unidadesNegocio?.[0]?._id ?? ""
            ),
            cliente: a.clientes?.[0]?.nombre_comercial ?? "",
            idCliente: String(a.clientes?.[0]?._id ?? ""),
            area: a.areas?.[0]?.name ?? "",
            idArea: String(a.areas?.[0]?._id ?? ""),
            idArticulo: String(a.articulos?.[0]?._id ?? ""),
            costoMX, // costo unitario
            precio,
            precioBruto,
            cantidad,
            entregado,
            porEntregar,
          };
        })
        .filter(Boolean);

      // ✅ Index para usar datos de artículo/cliente en renglones "SIN VENTA"
      const infoIndex = arrayTabla.reduce((acc, it) => {
        const idArticulo = String(it.idArticulo ?? "");
        if (!idArticulo) return acc;
        if (!acc[idArticulo]) {
          acc[idArticulo] = {
            SKU: it.SKU,
            nombre: it.nombre,
            marca: it.marca,
            idMarca: it.idMarca,
            unidadNegocio: it.unidadNegocio,
            idUnidadNegocio: it.idUnidadNegocio,
          };
        }
        return acc;
      }, {});

      const clienteIndex = arrayTabla.reduce((acc, it) => {
        const idCliente = String(it.idCliente ?? "");
        if (!idCliente) return acc;
        if (!acc[idCliente]) acc[idCliente] = { cliente: it.cliente };
        return acc;
      }, {});

      // 2) Devoluciones en buckets por (articulo, cliente) y lista de precios
      // devBuckets["idArticulo|idCliente"] = [{ precio, qty, used }]
      const devBuckets = allDevol.reduce((acc, d) => {
        const idArticulo = String(d.idArticulo ?? "");
        const idCliente = String(d.idCliente ?? "");
        const precio = round2(d.precio ?? 0);
        const qty = Number(d.cantidadDevuelta ?? 0);

        if (!idArticulo || !idCliente || !qty) return acc;

        const k = keyBase(idArticulo, idCliente);
        (acc[k] = acc[k] ?? []).push({ precio, qty, used: 0 });
        return acc;
      }, {});

      // orden por precio para más consistencia
      Object.values(devBuckets).forEach((list) => list.sort((a, b) => a.precio - b.precio));

      // helper: escoger la devolución con precio más cercano (diff < 1) y con saldo
      const pickClosestDevEntry = (bucketList, targetPrecio) => {
        if (!bucketList?.length) return null;

        let best = null;
        let bestDiff = Infinity;

        for (const entry of bucketList) {
          const remaining = Number(entry.qty ?? 0) - Number(entry.used ?? 0);
          if (remaining <= 0) continue;

          const diff = Math.abs(Number(entry.precio ?? 0) - Number(targetPrecio ?? 0));
          if (diff < ABS_TOL && diff < bestDiff) {
            best = entry;
            bestDiff = diff;
          }
        }
        return best;
      };

      // 3) Agrupa ventas por: articulo|cliente|area|precio|precioBruto
      // y guarda total vendido por clave SIN área PERO con precioBruto (para reparto)
      const totalsSinArea = {}; // keyVentaSinArea -> qty vendido
      const agrupadoObj = arrayTabla.reduce((groups, item) => {
        const precioClave = round2(item.precio);
        const precioBrutoClave = round2(item.precioBruto);
        const key = `${item.idArticulo}|${item.idCliente}|${item.idArea}|${precioClave}|${precioBrutoClave}`;

        if (!groups[key]) {
          groups[key] = {
            idArticulo: item.idArticulo,
            idCliente: item.idCliente,
            idArea: item.idArea,
            precio: precioClave,
            precioBruto: precioBrutoClave,
            SKU: item.SKU,
            nombre: item.nombre,
            cliente: item.cliente,
            marca: item.marca,
            idMarca: item.idMarca,
            unidadNegocio: item.unidadNegocio,
            idUnidadNegocio: item.idUnidadNegocio,
            area: item.area,

            costoMX: Number(item.costoMX ?? 0),

            // acumulados (BRUTOS)
            cantidad: 0,
            entregado: 0,
            porEntregar: 0,
            totalCosto: 0,

            // devoluciones asignadas
            cantidadDevuelta: 0,

            // opcional: para debug
            precioDevolucionUsado: null,
          };
        }

        const grupo = groups[key];
        const costoUnitario = Number(item.costoMX ?? grupo.costoMX ?? 0);

        grupo.cantidad += item.cantidad;
        grupo.entregado += item.entregado;
        grupo.porEntregar += item.porEntregar;
        grupo.totalCosto += costoUnitario * item.cantidad;

        const kSinArea = keyVentaSinArea(item.idArticulo, item.idCliente, precioBrutoClave);
        totalsSinArea[kSinArea] = (totalsSinArea[kSinArea] ?? 0) + item.cantidad;

        return groups;
      }, {});

      // 4) Repartir devoluciones ignorando área, con tolerancia de precio
      const grupos = Object.values(agrupadoObj);

      // Agrupa grupos por (articulo, cliente, precioBruto) para repartir proporcional
      const gruposPorVentaSinArea = grupos.reduce((acc, g) => {
        const k = keyVentaSinArea(g.idArticulo, g.idCliente, g.precioBruto);
        (acc[k] = acc[k] ?? []).push(g);
        return acc;
      }, {});

      Object.entries(gruposPorVentaSinArea).forEach(([kVenta, lista]) => {
        const [idArticulo, idCliente, precioBrutoStr] = String(kVenta).split("|");
        const precioBruto = Number(precioBrutoStr ?? 0);

        const bucket = devBuckets[keyBase(idArticulo, idCliente)] ?? [];
        const devEntry = pickClosestDevEntry(bucket, precioBruto);
        if (!devEntry) return;

        const vendidoTotal = Number(totalsSinArea[kVenta] ?? 0);
        if (!vendidoTotal) return;

        const devDisponible = Math.max(
          0,
          Number(devEntry.qty ?? 0) - Number(devEntry.used ?? 0)
        );
        if (!devDisponible) return;

        // Reparte lo disponible de esa devolución entre las áreas (proporcional a ventas)
        let acumulado = 0;
        lista.forEach((g, idx) => {
          if (idx === lista.length - 1) {
            const asignada = Math.max(0, devDisponible - acumulado);
            g.cantidadDevuelta = (g.cantidadDevuelta ?? 0) + asignada;
            g.precioDevolucionUsado = devEntry.precio;
          } else {
            const parte = devDisponible * (Number(g.cantidad ?? 0) / vendidoTotal);
            const asignada = Math.round(parte);
            g.cantidadDevuelta = (g.cantidadDevuelta ?? 0) + asignada;
            g.precioDevolucionUsado = devEntry.precio;
            acumulado += asignada;
          }
        });

        // Marca consumida
        devEntry.used = Number(devEntry.used ?? 0) + devDisponible;
      });

      // ✅ 4.1) Devoluciones sobrantes (no matchearon por tolerancia o sobró qty) => renglón aparte
      const devolucionesSinVenta = [];
      Object.entries(devBuckets).forEach(([kB, list]) => {
        const [idArticulo, idCliente] = String(kB).split("|");
        const art = infoIndex[idArticulo] ?? {};
        const cli = clienteIndex[idCliente] ?? {};

        list.forEach((entry) => {
          const remaining = Math.max(
            0,
            Number(entry.qty ?? 0) - Number(entry.used ?? 0)
          );
          if (!remaining) return;

          const precioDev = round2(entry.precio ?? 0);

          devolucionesSinVenta.push({
            idArticulo,
            idCliente,
            idArea: "",

            SKU: art.SKU ?? "",
            nombre: art.nombre ?? "",
            marca: art.marca ?? "",
            idMarca: art.idMarca ?? "",
            unidadNegocio: art.unidadNegocio ?? "",
            idUnidadNegocio: art.idUnidadNegocio ?? "",
            cliente: cli.cliente ?? "",
            area: "SIN VENTA (DEVOLUCIÓN)",

            // ✅ precio de la devolución
            precio: precioDev,
            precioBruto: precioDev,

            // ventas 0
            cantidad: 0,
            entregado: 0,
            porEntregar: 0,
            totalCosto: 0,

            // devolución
            cantidadDevuelta: remaining,

            // costo unitario desconocido en devolución sin venta (0)
            costoMX: 0,
          });
        });
      });

      const gruposConExtras = [...grupos, ...devolucionesSinVenta];

      // 5) Calcular métricas NETAS
      const agrupadoValues = gruposConExtras
        .map((g) => {
          const costoUnitario = Number(g.costoMX ?? 0);

          const cantidad = Number(g.cantidad ?? 0);
          const cantidadDevuelta = Number(g.cantidadDevuelta ?? 0);

          // ✅ si es renglón solo de devolución: neto NEGATIVO
          const esSoloDevol = cantidad === 0 && cantidadDevuelta > 0;
          const cantidadVentaReal = esSoloDevol
            ? -cantidadDevuelta
            : Math.max(0, cantidad - cantidadDevuelta);

          const precioUnit = Number(g.precio ?? 0);
          const precioBrutoUnit = Number(g.precioBruto ?? 0);

          // Totales netos (negativos en devolución sin venta)
          const total = precioUnit * cantidadVentaReal;
          const totalBruto = precioBrutoUnit * cantidadVentaReal;

          const costoTotal = costoUnitario * cantidadVentaReal;

          const utilidad = total - costoTotal;
          const utilidadBruta = totalBruto - costoTotal;

          const utilidadPorcentaje = total ? (utilidad / total) * 100 : 0;
          const utilidadPorcentajeBruto = totalBruto
            ? (utilidadBruta / totalBruto) * 100
            : 0;

          return {
            ...g,
            cantidadVentaReal,

            precioPromedio: precioUnit,
            precioPromedioBruto: precioBrutoUnit,

            total,
            totalBruto,

            costoTotal,
            totalCosto: costoTotal,

            totalPrecio: total,
            totalPrecioBruto: totalBruto,

            utilidad,
            utilidadBruta,

            utilidadPorcentaje: round2(utilidadPorcentaje),
            utilidadPorcentajeBruto: round2(utilidadPorcentajeBruto),
          };
        })
        .sort((a, b) => {
          if (a.SKU > b.SKU) return 1;
          if (a.SKU < b.SKU) return -1;

          if (!a.SKU && b.SKU) return 1;
          if (a.SKU && !b.SKU) return -1;

          if (a.precioBruto !== b.precioBruto) return a.precioBruto - b.precioBruto;
          return a.precio - b.precio;
        });

      setComments(agrupadoValues);

      setClientes(clientesRes.data ?? []);
      setMarcas(marcasRes.data ?? []);
      setUnidadesNegocio(unRes.data ?? []);

      setCargando(false);
      Toast.close();
    } catch (err) {
      console.log(err);
      setCargando(false);
      Toast.close();
    }
  };

  fetchAll();
}, []);

function BuscaInfo() {
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const round2 = (n) =>
    Math.round((Number(n || 0) + Number.EPSILON) * 100) / 100;

  const ABS_TOL = 1; // ✅ tolerancia: < $1

  // key base SIN precio (para agrupar devoluciones y ventas por artículo/cliente)
  const keyBase = (idArticulo, idCliente) => `${idArticulo}|${idCliente}`;

  // key de venta SIN área pero con precioBruto (para acumular vendidos por precioBruto)
  const keyVentaSinArea = (idArticulo, idCliente, precioBruto) =>
    `${idArticulo}|${idCliente}|${round2(precioBruto)}`;

  setComments([]);
  setCargando(true);

  Promise.all([
    axios.get(
      `${URL_ARTICULOS_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    ),
    axios.get(
      `${URL_ARTICULOS_DEVOLUCIONES}Fechas/${selectedFechaInicio}/${selectedFechaFin}`,
      { headers }
    ),
  ])
    .then(([ventasRes, devolRes]) => {
      const allVentas = ventasRes.data ?? [];
      const allDevol = devolRes.data ?? [];

      // 1) Normaliza ventas
      const arrayTabla = allVentas
        .map((a) => {
          const precio = Number(a?.precio ?? 0);
          const precioBruto = Number(a?.precioBruto ?? 0);
          const cantidad = Number(a?.cantidad ?? 0);
          const entregado = Number(a?.entregadoCantidad ?? 0);
          const porEntregar = Number(a?.porEntregar ?? 0);
          const costoMX = Number(a?.costoUnitario ?? 0);

          return {
            SKU: a.articulos?.[0]?.SKU ?? "",
            nombre: a.articulos?.[0]?.nombre ?? "",
            marca: a.articulos?.[0]?.marcas?.[0]?.name ?? "",
            idMarca: String(a.articulos?.[0]?.marcas?.[0]?._id ?? ""),
            unidadNegocio: a.articulos?.[0]?.unidadesNegocio?.[0]?.name ?? "",
            idUnidadNegocio: String(
              a.articulos?.[0]?.unidadesNegocio?.[0]?._id ?? ""
            ),
            cliente: a.clientes?.[0]?.nombre_comercial ?? "",
            idCliente: String(a.clientes?.[0]?._id ?? ""),
            area: a.areas?.[0]?.name ?? "",
            idArea: String(a.areas?.[0]?._id ?? ""),
            idArticulo: String(a.articulos?.[0]?._id ?? ""),
            costoMX,
            precio,
            precioBruto,
            cantidad,
            entregado,
            porEntregar,
          };
        })
        .filter(Boolean);

      // 2) Devoluciones agrupadas por (artículo, cliente) con lista de precios
      // devBuckets[ "idArticulo|idCliente" ] = [{ precio, qty, used }]
      const devBuckets = allDevol.reduce((acc, d) => {
        const idArticulo = String(d.idArticulo ?? "");
        const idCliente = String(d.idCliente ?? "");
        const precio = round2(d.precio ?? 0);
        const qty = Number(d.cantidadDevuelta ?? 0);

        if (!idArticulo || !idCliente || !qty) return acc;

        const k = keyBase(idArticulo, idCliente);
        (acc[k] = acc[k] ?? []).push({
          precio,
          qty,
          used: 0, // cuánto ya “consumimos” de esta devolución
        });
        return acc;
      }, {});

      // ordena cada bucket por precio (para búsqueda más estable)
      Object.values(devBuckets).forEach((list) => {
        list.sort((a, b) => a.precio - b.precio);
      });

      // 3) Agrupa ventas igual que antes (con área)
      //    y además acumula vendido total por (artículo, cliente, precioBruto) para repartir
      const totalsSinArea = {}; // keyVentaSinArea -> qty vendido
      const agrupadoObj = arrayTabla.reduce((groups, item) => {
        const precioClave = round2(item.precio);
        const precioBrutoClave = round2(item.precioBruto);

        const key = `${item.idArticulo}|${item.idCliente}|${item.idArea}|${precioClave}|${precioBrutoClave}`;

        if (!groups[key]) {
          groups[key] = {
            idArticulo: item.idArticulo,
            idCliente: item.idCliente,
            idArea: item.idArea,
            precio: precioClave,
            precioBruto: precioBrutoClave,
            SKU: item.SKU,
            nombre: item.nombre,
            cliente: item.cliente,
            marca: item.marca,
            idMarca: item.idMarca,
            unidadNegocio: item.unidadNegocio,
            idUnidadNegocio: item.idUnidadNegocio,
            area: item.area,

            costoMX: Number(item.costoMX ?? 0),

            cantidad: 0,
            entregado: 0,
            porEntregar: 0,
            totalPrecio: 0,
            totalPrecioBruto: 0,
            totalCosto: 0,

            cantidadDevuelta: 0,

            // para saber qué precio de devolución se terminó usando (útil para debug/UI)
            precioDevolucionUsado: null,
          };
        }

        const grupo = groups[key];
        const costoUnitario = Number(item.costoMX ?? grupo.costoMX ?? 0);

        grupo.cantidad += item.cantidad;
        grupo.entregado += item.entregado;
        grupo.porEntregar += item.porEntregar;
        grupo.totalPrecio += item.precio * item.cantidad;
        grupo.totalPrecioBruto += item.precioBruto * item.cantidad;
        grupo.totalCosto += costoUnitario * item.cantidad;

        // vendido por key sin área + precioBruto
        const kSinArea = keyVentaSinArea(item.idArticulo, item.idCliente, precioBrutoClave);
        totalsSinArea[kSinArea] = (totalsSinArea[kSinArea] ?? 0) + item.cantidad;

        return groups;
      }, {});

      const grupos = Object.values(agrupadoObj);

      // Helpers para escoger la devolución "más cercana" por precio dentro de tolerancia
      const pickClosestDevEntry = (bucketList, targetPrecio) => {
        if (!bucketList?.length) return null;

        let best = null;
        let bestDiff = Infinity;

        for (const entry of bucketList) {
          const remaining = (entry.qty ?? 0) - (entry.used ?? 0);
          if (remaining <= 0) continue;

          const diff = Math.abs(Number(entry.precio ?? 0) - Number(targetPrecio ?? 0));
          if (diff < ABS_TOL && diff < bestDiff) {
            best = entry;
            bestDiff = diff;
          }
        }
        return best;
      };

      // 4) Repartir devoluciones ignorando área
      // Agrupamos grupos por (artículo, cliente, precioBruto) para repartir proporcionalmente
      const gruposPorVentaSinArea = grupos.reduce((acc, g) => {
        const k = keyVentaSinArea(g.idArticulo, g.idCliente, g.precioBruto);
        (acc[k] = acc[k] ?? []).push(g);
        return acc;
      }, {});

      Object.entries(gruposPorVentaSinArea).forEach(([kVenta, lista]) => {
        const [idArticulo, idCliente, precioBrutoStr] = String(kVenta).split("|");
        const precioBruto = Number(precioBrutoStr ?? 0);

        const bucket = devBuckets[keyBase(idArticulo, idCliente)] ?? [];
        const devEntry = pickClosestDevEntry(bucket, precioBruto);

        if (!devEntry) return;

        const vendidoTotal = Number(totalsSinArea[kVenta] ?? 0);
        if (!vendidoTotal) return;

        // lo que queda disponible en esa devolución elegida
        const devDisponible = Math.max(
          0,
          Number(devEntry.qty ?? 0) - Number(devEntry.used ?? 0)
        );
        if (!devDisponible) return;

        // repartimos TODA la disponible para ese precioBruto (si hay más de un grupo/área)
        let acumulado = 0;
        lista.forEach((g, idx) => {
          if (idx === lista.length - 1) {
            const asignada = Math.max(0, devDisponible - acumulado);
            g.cantidadDevuelta = (g.cantidadDevuelta ?? 0) + asignada;
            g.precioDevolucionUsado = devEntry.precio;
          } else {
            const parte = devDisponible * (Number(g.cantidad ?? 0) / vendidoTotal);
            const asignada = Math.round(parte); // o round2(parte) si quieres decimales
            g.cantidadDevuelta = (g.cantidadDevuelta ?? 0) + asignada;
            g.precioDevolucionUsado = devEntry.precio;
            acumulado += asignada;
          }
        });

        // marcamos como consumido en el bucket
        devEntry.used = Number(devEntry.used ?? 0) + devDisponible;
      });

      // ✅ 4.1) Devoluciones SOBRANTES (no consumidas / o sin match por tolerancia) => renglón aparte
      const infoIndex = arrayTabla.reduce((acc, it) => {
        const idArticulo = String(it.idArticulo ?? "");
        if (!idArticulo) return acc;
        if (!acc[idArticulo]) {
          acc[idArticulo] = {
            SKU: it.SKU,
            nombre: it.nombre,
            marca: it.marca,
            idMarca: it.idMarca,
            unidadNegocio: it.unidadNegocio,
            idUnidadNegocio: it.idUnidadNegocio,
          };
        }
        return acc;
      }, {});

      const clienteIndex = arrayTabla.reduce((acc, it) => {
        const idCliente = String(it.idCliente ?? "");
        if (!idCliente) return acc;
        if (!acc[idCliente]) {
          acc[idCliente] = { cliente: it.cliente };
        }
        return acc;
      }, {});

      const devolucionesSinVenta = [];
      Object.entries(devBuckets).forEach(([kBase, list]) => {
        const [idArticulo, idCliente] = String(kBase).split("|");
        const art = infoIndex[idArticulo] ?? {};
        const cli = clienteIndex[idCliente] ?? {};

        list.forEach((entry) => {
          const remaining = Math.max(
            0,
            Number(entry.qty ?? 0) - Number(entry.used ?? 0)
          );
          if (!remaining) return;

          const precioDev = round2(entry.precio ?? 0);

          devolucionesSinVenta.push({
            idArticulo,
            idCliente,
            idArea: "",

            SKU: art.SKU ?? "",
            nombre: art.nombre ?? "",
            marca: art.marca ?? "",
            idMarca: art.idMarca ?? "",
            unidadNegocio: art.unidadNegocio ?? "",
            idUnidadNegocio: art.idUnidadNegocio ?? "",
            cliente: cli.cliente ?? "",
            area: "SIN VENTA (DEVOLUCIÓN)",

            // mostrar precio de la devolución
            precio: precioDev,
            precioBruto: precioDev,

            // ventas en 0
            cantidad: 0,
            entregado: 0,
            porEntregar: 0,
            totalPrecio: 0,
            totalPrecioBruto: 0,

            costoMX: 0,
            totalCosto: 0,

            cantidadDevuelta: remaining,
          });
        });
      });

      const gruposConExtras = [...grupos, ...devolucionesSinVenta];

      // 5) Calcular métricas NETAS con cantidadVentaReal
      const agrupadoValues = gruposConExtras
        .map((g) => {
          const cantidad = Number(g.cantidad ?? 0);
          const cantidadDevuelta = Number(g.cantidadDevuelta ?? 0);

          const esSoloDevol = cantidad === 0 && cantidadDevuelta > 0;
          const cantidadVentaReal = esSoloDevol
            ? -cantidadDevuelta
            : Math.max(0, cantidad - cantidadDevuelta);

          const precioUnit = Number(g.precio ?? 0);
          const precioBrutoUnit = Number(g.precioBruto ?? 0);
          const costoUnitario = Number(g.costoMX ?? 0);

          const total = precioUnit * cantidadVentaReal;
          const totalBruto = precioBrutoUnit * cantidadVentaReal;
          const costoTotal = costoUnitario * cantidadVentaReal;

          const utilidad = total - costoTotal;
          const utilidadBruta = totalBruto - costoTotal;

          const utilidadPorcentaje = total ? (utilidad / total) * 100 : 0;
          const utilidadPorcentajeBruto = totalBruto
            ? (utilidadBruta / totalBruto) * 100
            : 0;

          return {
            ...g,
            cantidadVentaReal,

            precioPromedio: cantidad ? g.totalPrecio / cantidad : 0,
            precioPromedioBruto: cantidad ? g.totalPrecioBruto / cantidad : 0,

            total,
            totalBruto,
            costoTotal,
            totalCosto: costoTotal,
            totalPrecio: total,
            totalPrecioBruto: totalBruto,

            utilidad,
            utilidadBruta,
            utilidadPorcentaje: round2(utilidadPorcentaje),
            utilidadPorcentajeBruto: round2(utilidadPorcentajeBruto),
          };
        })
        .sort((a, b) => {
          if (a.SKU > b.SKU) return 1;
          if (a.SKU < b.SKU) return -1;

          if (!a.SKU && b.SKU) return 1;
          if (a.SKU && !b.SKU) return -1;

          if (a.precioBruto !== b.precioBruto) return a.precioBruto - b.precioBruto;
          return a.precio - b.precio;
        });

      setComments(agrupadoValues);
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
      setCargando(false);
      Toast.close();
    });
}


  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.idMarca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          a.area,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalCosto),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedioBruto),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecioBruto),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.utilidad),
          new Intl.NumberFormat("en-US", {maximumFractionDigits: 2}).format(a.utilidadPorcentaje) + "%",
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Almacen",
          "Cantidad",
          "Costo MX",
          "Costo Total",
          "Precio Promedio Bruto",
          "Precio Promedio Neto",
          "Total Bruto",
          "Total Neto",
          "Utilidad",
          "% Utilidad",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    // doc.save(`Ventas.pdf`);
    window.open(doc.output("bloburl"), "_blank");
  }

// function excel() {
//   // 1. Filtrado por cliente y marca
//   let filtered = comments.filter(
//     (a) =>
//       (selectedCliente === "" || selectedCliente === a.idCliente) &&
//       (selectedMarca === "" || selectedMarca === a.idMarca)&&
//         (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
//   );

//   // 2. Filtro por texto de búsqueda
//   if (search && search.trim() !== "") {
//     const searchLower = search.toLowerCase();
//     filtered = filtered.filter((a) =>
//       (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
//       (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
//       (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
//       (a.cliente && a.cliente.toLowerCase().includes(searchLower)) ||
//       (a.area && a.area.toLowerCase().includes(searchLower)) ||
//       (a.cantidad != null && a.cantidad.toString().includes(searchLower)) ||
//       (a.entregado != null && a.entregado.toString().includes(searchLower)) ||
//       (a.porEntregar != null && a.porEntregar.toString().includes(searchLower)) ||
//       (a.precioPromedio != null && a.precioPromedio.toString().includes(searchLower)) ||
//       (a.precioPromedioBruto != null && a.precioPromedioBruto.toString().includes(searchLower)) ||
//       (a.totalPrecioBruto != null && a.totalPrecioBruto.toString().includes(searchLower)) ||
//       (a.totalPrecio != null && a.totalPrecio.toString().includes(searchLower))
//     );
//   }

//   // 3. Mapear datos a exportar
//   const dataExcel = filtered.map((a) => ({
//     SKU: a.SKU,
//     Nombre: a.nombre,
//     Marca: a.marca,
//     Cliente: a.cliente,
//     Almacen: a.area,
//     Cantidad: a.cantidad,
//     Costo: Number(a.costoMX.toFixed(2)),
//     TotalCosto: Number(a.totalCosto.toFixed(2)),
//     PrecioPromedioBruto: Number(a.precioPromedioBruto.toFixed(2)),
//     PrecioPromedioNeto: Number(a.precioPromedio.toFixed(2)),
//     TotalBruto: Number(a.totalPrecioBruto.toFixed(2)),
//     TotalNeto: Number(a.totalPrecio.toFixed(2)),
//     Utilidad: Number(a.utilidad.toFixed(2)),
//     PorcentajeUtilidad: Number(a.utilidadPorcentaje.toFixed(2)),
//   }));

//   const dataExcelLimpia = dataExcel.filter((el) => el != null);

//   const option = {
//     fileName: "ReporteVentasArticulos",
//     datas: [
//       {
//         sheetData: dataExcelLimpia,
//         sheetName: "ReporteVentasArticulos",
//         sheetFilter: [
//           "SKU",
//           "Nombre",
//           "Marca",
//           "Cliente",
//           "Almacen",
//           "Cantidad",
//           "Costo",
//           "TotalCosto",
//           "PrecioPromedioBruto",
//           "PrecioPromedioNeto",
//           "TotalBruto",
//           "TotalNeto",
//           "Utilidad",
//           "PorcentajeUtilidad",
//         ],
//         sheetHeader: [
//            "SKU",
//           "Nombre",
//           "Marca",
//           "Cliente",
//           "Almacen",
//           "Cantidad",
//           "Costo",
//           "TotalCosto",
//           "PrecioPromedioBruto",
//           "PrecioPromedioNeto",
//           "TotalBruto",
//           "TotalNeto",
//           "Utilidad",
//           "PorcentajeUtilidad",
//         ],
//       },
//     ],
//   };

//   const toExcel = new ExportJsonExcel(option);
//   toExcel.saveExcel();
// }

function excel() {
  // 1. Filtrado por cliente y marca
  let filtered = comments.filter(
    (a) =>
      (selectedCliente === "" || selectedCliente === a.idCliente) &&
      (selectedMarca === "" || selectedMarca === a.idMarca)&&
      (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
  );

  // 2. Filtro por texto de búsqueda
  if (search && search.trim() !== "") {
    const searchLower = search.toLowerCase();
    filtered = filtered.filter((a) =>
      (a.SKU && a.SKU.toLowerCase().includes(searchLower)) ||
      (a.nombre && a.nombre.toLowerCase().includes(searchLower)) ||
      (a.marca && a.marca.toLowerCase().includes(searchLower)) ||
      (a.cliente && a.cliente.toLowerCase().includes(searchLower)) ||
      (a.area && a.area.toLowerCase().includes(searchLower)) ||
      (a.cantidad != null && a.cantidad.toString().includes(searchLower)) ||
      (a.entregado != null && a.entregado.toString().includes(searchLower)) ||
      (a.porEntregar != null && a.porEntregar.toString().includes(searchLower)) ||
      (a.precioPromedio != null && a.precioPromedio.toString().includes(searchLower)) ||
      (a.precioPromedioBruto != null && a.precioPromedioBruto.toString().includes(searchLower)) ||
      (a.totalPrecioBruto != null && a.totalPrecioBruto.toString().includes(searchLower)) ||
      (a.totalPrecio != null && a.totalPrecio.toString().includes(searchLower))
    );
  }

  // 3. Mapear datos a exportar
  const dataExcel = filtered.map((a) => ({
    SKU: a.SKU,
    Nombre: a.nombre,
    Marca: a.marca,
    Cliente: a.cliente,
    Almacen: a.area,
    Cantidad: a.cantidad,
    Devoluciones: a.cantidadDevuelta,
    CantidadReal: a.cantidadVentaReal,
    Costo: Number(a.costoMX.toFixed(2)),
    TotalCosto: Number(a.totalCosto.toFixed(2)),
    PrecioPromedioBruto: Number(a.precioPromedioBruto.toFixed(2)),
    PrecioPromedioNeto: Number(a.precioPromedio.toFixed(2)),
    TotalBruto: Number(a.totalPrecioBruto.toFixed(2)),
    TotalNeto: Number(a.totalPrecio.toFixed(2)),
    Utilidad: Number(a.utilidad.toFixed(2)),
    PorcentajeUtilidad: Number(a.utilidadPorcentaje.toFixed(2)),
  }));

  const dataExcelLimpia = dataExcel.filter((el) => el != null);

  // === 4. Agregar totales al final ===
  const totalCantidad = filtered.reduce((acc, a) => acc + Number(a.cantidad || 0), 0);
  const totalTotalCantidadDev = filtered.reduce((acc, a) => acc + Number(a.cantidadDevuelta || 0), 0);
  const totalTotalCantidadVentaReal = filtered.reduce((acc, a) => acc + Number(a.cantidadVentaReal || 0), 0);
  const totalCosto = filtered.reduce((acc, a) => acc + Number(a.totalCosto || 0), 0);
  const totalBruto = filtered.reduce((acc, a) => acc + Number(a.totalPrecioBruto || 0), 0);
  const totalNeto = filtered.reduce((acc, a) => acc + Number(a.totalPrecio || 0), 0);
  const totalUtilidad = filtered.reduce((acc, a) => acc + Number(a.utilidad || 0), 0);
  const porcentajeUtilidadTotal = totalNeto > 0 ? Number(((totalUtilidad / totalNeto) * 100).toFixed(2)) : 0;
  dataExcelLimpia.push({
    SKU: "",
    Nombre: "",
    Marca: "",
    Cliente: "",
    Almacen: "TOTAL GENERAL",
    Cantidad: totalCantidad,
    Devoluciones: totalTotalCantidadDev,
    CantidadReal: totalTotalCantidadVentaReal,
    Costo: "",
    TotalCosto: Number(totalCosto.toFixed(2)),
    PrecioPromedioBruto: "",
    PrecioPromedioNeto: "",
    TotalBruto: Number(totalBruto.toFixed(2)),
    TotalNeto: Number(totalNeto.toFixed(2)),
    Utilidad: Number(totalUtilidad.toFixed(2)),
    PorcentajeUtilidad: porcentajeUtilidadTotal,
  });

  // === Exportar ===
  const option = {
    fileName: "ReporteVentasArticulos",
    datas: [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ReporteVentasArticulos",
        sheetFilter: [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Almacen",
          "Cantidad",
          "Devoluciones",
          "CantidadReal",
          "Costo",
          "TotalCosto",
          "PrecioPromedioBruto",
          "PrecioPromedioNeto",
          "TotalBruto",
          "TotalNeto",
          "Utilidad",
          "PorcentajeUtilidad",
        ],
        sheetHeader: [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Almacen",
          "Cantidad",
          "Devoluciones",
          "CantidadReal",
          "Costo",
          "TotalCosto",
          "PrecioPromedioBruto",
          "PrecioPromedioNeto",
          "TotalBruto",
          "TotalNeto",
          "Utilidad",
          "PorcentajeUtilidad",
        ],
      },
    ],
  };

  const toExcel = new ExportJsonExcel(option);
  toExcel.saveExcel();
}



  function enviaMail() {
    const data = comments.map((a) => {
      if (
        // (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        // (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (selectedCliente == "" || selectedCliente == a.idCliente)&&
        (selectedMarca == "" || selectedMarca == a.idMarca)&&
        (selectedUnidadNegocio == "" || selectedUnidadNegocio == a.idUnidadNegocio)
      ) {
        return [
          a.SKU,
          a.nombre,
          a.marca,
          a.cliente,
          new Intl.NumberFormat("en-US").format(a.cantidad),
          new Intl.NumberFormat("en-US").format(a.entregado),
          new Intl.NumberFormat("en-US").format(a.porEntregar),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Reporte Ventas Articulo`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "SKU",
          "Nombre",
          "Marca",
          "Cliente",
          "Cantidad",
          "Entregado",
          "Por Entregar",
          "Precio Promedio",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode.encode(att, "base64");

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Reporte Ventas Articulo",
          email: mailTo,
          fileName: "ReporteVentasArticulos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Reporte Ventas Articulo.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "SKU", field: "SKU", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Marca", field: "marca", sortable: true },
    { name: "Cliente", field: "cliente", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Devoluciones", field: "cantidadDevuelta", sortable: true },
    { name: "Cantidad Real", field: "cantidadVentaReal", sortable: true },
    { name: "Costo", field: "costoMX", sortable: true },
    { name: "Total Costo", field: "totalCosto", sortable: true },
    // { name: "Cantidad Entregada", field: "entregado", sortable: true },
    // { name: "Cantidad Por Entregar", field: "porEntregar", sortable: true },
    { name: "Precio Promedio Bruto", field: "precioPromedioBruto", sortable: true },
    { name: "Precio Promedio Neto", field: "precioPromedio", sortable: true },
    { name: "Total Bruto", field: "totalPrecioBruto", sortable: true },
    { name: "Total Neto", field: "totalPrecio", sortable: true },
    { name: "Utilidad $", field: "utilidad", sortable: true },
    { name: "Utilidad %", field: "utilidadPorcentaje", sortable: true },
    
  ];


  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.SKU.toLowerCase().includes(search.toLowerCase()) ||
        comment.nombre.toLowerCase().includes(search.toLowerCase()) ||
        comment.marca.toLowerCase().includes(search.toLowerCase()) ||
          comment.cliente.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.cantidad.toString().includes(search) ||
          comment.cantidadDevuelta.toString().includes(search) ||
          comment.cantidadVentaReal.toString().includes(search) ||
          comment.entregado.toString().includes(search) ||
          comment.porEntregar.toString().includes(search) ||
          comment.precioPromedio.toString().includes(search) ||
          comment.precioPromedioBruto.toString().includes(search) ||
          comment.totalPrecioBruto.toString().includes(search) ||
          comment.totalPrecio.toString().includes(search) ||
          comment.costoMX.toString().includes(search) ||
          comment.totalCosto.toString().includes(search) ||
          comment.utilidad.toString().includes(search) ||
          comment.utilidadPorcentaje.toString().includes(search) 
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idCliente.includes(selectedCliente)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }

    if (selectedUnidadNegocio) {
      computedComments = computedComments.filter((e) =>
        e.idUnidadNegocio.includes(selectedUnidadNegocio)
      );
    }

    setTotalItems(computedComments.length);

    let cant = computedComments.map((c) => parseFloat(c.cantidad));
    let Tcant = cant.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidad(Tcant);

        let cantDev = computedComments.map((c) => parseFloat(c.cantidadDevuelta));
    let TcantDev = cantDev.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadDev(TcantDev);

    let cantVen = computedComments.map((c) => parseFloat(c.cantidadVentaReal));
    let TcantVen = cantVen.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadVentaReal(TcantVen);

    let cantEnt = computedComments.map((c) => parseFloat(c.entregado));
    let TcantEnt = cantEnt.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadEntregado(TcantEnt);

    let cantPor = computedComments.map((c) => parseFloat(c.porEntregar));
    let TcantPor = cantPor.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCantidadPorEntregar(TcantPor);

    let totCos = computedComments.map((c) => parseFloat(c.totalCosto));
    let TtotCos = totCos.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalCosto(TtotCos);

        let totUti = computedComments.map((c) => parseFloat(c.utilidad));
    let TtotUti = totUti.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalUtilidad(TtotUti);

    let cantTot = computedComments.map((c) => parseFloat(c.totalPrecio));
    let TcantTot = cantTot.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDinero(TcantTot);

    let cantTotBruto = computedComments.map((c) => parseFloat(c.totalPrecioBruto));
    let TcantTotBruto = cantTotBruto.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalDineroBruto(TcantTotBruto);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "cantidad" &&
      sorting.field != "cantidadDevuelta" &&
      sorting.field != "cantidadVentaReal" &&
      sorting.field != "entregado" &&
      sorting.field != "porEntregar" &&
      sorting.field != "precioPromedio" &&
      sorting.field != "precioPromedioBruto" &&
      sorting.field != "totalPrecioBruto" &&
      sorting.field != "totalPrecio" &&
      sorting.field != "costoMX" &&
      sorting.field != "totalCosto" &&
      sorting.field != "utilidad" &&
      sorting.field != "utilidadPorcentaje"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (
        sorting.field == "cantidad" ||
        sorting.field == "cantidadDevuelta" ||
        sorting.field == "cantidadVentaReal" ||
        sorting.field == "entregado" ||
        sorting.field == "porEntregar" ||
        sorting.field == "precioPromedio" ||
        sorting.field == "precioPromedioBruto" ||
        sorting.field == "totalPrecioBruto" ||
        sorting.field == "totalPrecio" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalCosto" ||
        sorting.field == "utilidad" ||
        sorting.field == "utilidadPorcentaje"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (
        sorting.field == "cantidad"||
        sorting.field == "cantidadDevuelta" ||
        sorting.field == "cantidadVentaReal" ||
        sorting.field == "entregado" ||
        sorting.field == "porEntregar" ||
        sorting.field == "precioPromedio" ||
        sorting.field == "precioPromedioBruto" ||
        sorting.field == "totalPrecioBruto" ||
        sorting.field == "totalPrecio" ||
        sorting.field == "costoMX" ||
        sorting.field == "totalCosto" ||
        sorting.field == "utilidad" ||
        sorting.field == "utilidadPorcentaje"
      )
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedMarca,
    selectedUnidadNegocio,
    selectedFechaInicio,
    selectedFechaFin,
  ]);


  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_ventas ? (
        <div className="card col-12">
          {/* Toolbar */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 16px 6px" }}>
            <h4 style={{ margin: 0, fontWeight: 700, color: "#1e3a8a" }}>📊 Reporte Ventas Artículo</h4>
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <Button size="sm" href="/MenuVentas" className="btn btn-danger">← Regresar</Button>
              <ButtonGroup>
                <Button size="sm" color="danger" onClick={PDFTabla}>PDF <i className="far fa-file-pdf"></i></Button>
                <Button size="sm" color="info" onClick={toggleMail}>eMail <i className="fas fa-at"></i></Button>
                <Button size="sm" color="primary" onClick={excel}>Excel <i className="far fa-file-excel"></i></Button>
              </ButtonGroup>
            </div>
          </div>

          {/* Filters */}
          <div style={{ background: "#f8fafc", borderRadius: 8, padding: "12px 16px", marginBottom: 14 }}>
            <div style={{ borderLeft: "4px solid #3b82f6", paddingLeft: 12, marginBottom: 8, color: "#1e3a8a", fontWeight: 600, fontSize: "0.85rem", textTransform: "uppercase", letterSpacing: "0.05em" }}>Filtros</div>
            <Row>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Fecha Inicio</Label>
                <Input bsSize="sm" type="date" value={selectedFechaInicio} required onChange={(e) => { setSelectedFechaInicio(e.target.value); setFechaModificada(true); }} />
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Fecha Fin</Label>
                <Input bsSize="sm" type="date" value={selectedFechaFin} required onChange={(e) => { setSelectedFechaFin(e.target.value); setFechaModificada(true); }} />
              </Col>
              <Col md={1} style={{ display: "flex", alignItems: "flex-end" }}>
                <Button size="sm" onClick={BuscaInfo} color={fechaModificada ? "danger" : "info"}>Actualizar</Button>
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Cliente</Label>
                <Input bsSize="sm" type="select" value={selectedCliente} onChange={(e) => { setSelectedCliente(e.target.value); setCurrentPage(1); }}>
                  <option value="0">Todos</option>
                  {clientes.sort((a, b) => a.nombre_comercial > b.nombre_comercial ? 1 : -1).map((a) => (
                    <option key={a._id} value={a._id}>{a.nombre_comercial}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Marca</Label>
                <Input bsSize="sm" type="select" value={selectedMarca} onChange={(e) => { setSelectedMarca(e.target.value); setCurrentPage(1); }}>
                  <option value="0">Todas</option>
                  {marcas.sort((a, b) => a.name > b.name ? 1 : -1).map((a) => (
                    <option key={a._id} value={a._id}>{a.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md={2}>
                <Label style={{ fontSize: "0.8rem" }}>Unidad Negocio</Label>
                <Input bsSize="sm" type="select" value={selectedUnidadNegocio} onChange={(e) => { setSelectedUnidadNegocio(e.target.value); setCurrentPage(1); }}>
                  <option value="0">Todas</option>
                  {unidadesNegocio.sort((a, b) => a.name > b.name ? 1 : -1).map((a) => (
                    <option key={a._id} value={a._id}>{a.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md={1}>
                <Label style={{ fontSize: "0.8rem" }}>Buscar</Label>
                <Search onSearch={(value) => { setSearch(value); setCurrentPage(1); }} />
              </Col>
            </Row>
          </div>

          {/* Pagination */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6 }}>
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
            <span style={{ background: "#dbeafe", color: "#1e3a8a", borderRadius: 20, padding: "3px 14px", fontWeight: 700, fontSize: "0.85rem" }}>
              {commentsData.length} artículos
            </span>
          </div>

          <div className="table-wrapper">
            <Table size="sm" bordered striped className="table-responsive-xl" style={{ fontSize: "0.82rem" }}>
              <TableHeader headers={headers} onSorting={(field, order) => setSorting({ field, order })} />
              <tbody>
                {commentsData.map((a) => (
                  <tr key={a._id || a.SKU}>
                    <td>{a.SKU}</td>
                    <td>{a.nombre}</td>
                    <td>{a.marca}</td>
                    <td>{a.cliente}</td>
                    <td>{a.area}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidad)}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidadDevuelta)}</td>
                    <td>{new Intl.NumberFormat("en-US").format(a.cantidadVentaReal)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.costoMX)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalCosto)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedioBruto)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precioPromedio)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecioBruto)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.totalPrecio)}</td>
                    <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.utilidad)}</td>
                    <td>{new Intl.NumberFormat("en-US", {maximumFractionDigits: 2}).format(a.utilidadPorcentaje)}%</td>
                  </tr>
                ))}
                <tr style={{ fontWeight: 700, background: "#f1f5f9" }}>
                  <td></td><td></td><td></td><td></td>
                  <td style={{ color: "#1e3a8a" }}>TOTAL</td>
                  <td>{new Intl.NumberFormat("en-US").format(totalTotalCantidad)}</td>
                  <td>{new Intl.NumberFormat("en-US").format(totalTotalCantidadDev)}</td>
                  <td>{new Intl.NumberFormat("en-US").format(totalTotalCantidadVentaReal)}</td>
                  <td></td>
                  <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalCosto)}</td>
                  <td></td><td></td>
                  <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDineroBruto)}</td>
                  <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalDinero)}</td>
                  <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalUtilidad)}</td>
                  <td>{((totalTotalUtilidad / totalTotalDinero) * 100).toFixed(2)}%</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <div className="col-md-6">
            <Pagination total={totalItems} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
          </div>
        </div>
      ) : undefined}
      <br />

      {/* Mail Modal */}
      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}><h4>Enviar Reporte Ventas Artículo</h4></ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input className="col-sm-12" type="text" value={mailTo} required onChange={(e) => setMailTo(e.target.value)} />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>Enviar</Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ReporteVentasArticulos;
